import { render, staticRenderFns } from "./Reductions.vue?vue&type=template&id=620c59f3&"
import script from "./Reductions.vue?vue&type=script&lang=js&"
export * from "./Reductions.vue?vue&type=script&lang=js&"
import style0 from "./Reductions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Reductions.vue"
export default component.exports